export enum PaymentAttemptStatusEnum {
  NotAttempted = "Not Attempted",
  Attempted = "Attempted",
  Completed = "Completed"
}

export default {}